import "./styled-jsx.fix";

import { AppProviderProps } from "./components/AppProvider";
import { loadScript } from "./utils/loadScript";

import type { BaseUrl } from ".";

declare const window: Window & {
  // Add explicit typings of configurations written to the DOM inside the HTML
  // output flushed by the server
  CATALOGUE_ID: string;
  CATALOGUE_BASE_URL: {
    protocol: string;
    hostname: string;
    pathname?: string;
  };

  // Add explicit typings for the render method used to inject the catalogue
  // into the DOM
  CATALOGUE_render?: (
    containerId: string,
    config: Omit<AppProviderProps, "containerId" | "feedUrl"> & {
      baseUrl: BaseUrl;
    }
  ) => void;
};

loadScript(process.env["CATALOGUE_BUNDLE_URL"] ?? "").then(() => {
  if (!window.CATALOGUE_render) {
    throw new Error("An error occurred while loading the catalogue!");
  }

  window.CATALOGUE_render("app", {
    catalogueId: window.CATALOGUE_ID,
    baseUrl: window.CATALOGUE_BASE_URL,
    inMemoryRouter: true,
  });
});
